import { Address } from '@frontend/api';

import { Facility } from './types';

export const convertFacilityToShippingInformation = (
  account: { name: string },
  contact: { firstName: string; lastName: string },
  facility: Facility,
) => {
  return {
    businessName: account.name,
    attention: facility.attention
      ? facility.attention
      : `${contact.firstName} ${contact.lastName}`,
    address: facility.address,
    facilityName: facility.name,
  };
};

export const convertBillingAddressToBillingInformation = (
  account: { name: string },
  contact: { firstName: string; lastName: string },
  billingAddress: { address: Address },
) => {
  return {
    businessName: account.name,
    attention: `${contact.firstName} ${contact.lastName}`,
    address: billingAddress.address,
  };
};

export const convertContactToAddressInformation = (contact: {
  firstName: string;
  lastName: string;
  address: Address;
}) => {
  const { firstName, lastName, address } = contact;
  return {
    firstName,
    lastName,
    address,
  };
};
